export default "__VITE_ASSET__DSp7gNnY__"